import { useQuery } from '@tanstack/react-query';
import { makeBookingManagerApi } from 'services/BookingManagerApi/BookingManagerApi';
import { IInvoiceUploadFileUrlResponse } from '../types';

export const INVOICE_UPLOAD_FILE_URL_QUERY_KEY = 'invoiceUploadFileUrl';

export const useInvoiceUploadFileUrlQuery = (importUuid: string | null | undefined) => {
  return useQuery<IInvoiceUploadFileUrlResponse | undefined>({
    queryKey: [INVOICE_UPLOAD_FILE_URL_QUERY_KEY, importUuid],
    queryFn: async () => {
      if (!importUuid) {
        return undefined;
      }
      const api = makeBookingManagerApi();
      const response = await api.getSupplierInvoiceImportFileUrl(importUuid);
      return response.data;
    },
    enabled: !!importUuid,
  });
};
